module.exports = __webpack_public_path__ + "img/prize_5.b36c454b.png";